import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ViewStateService {
    private viewSource = new BehaviorSubject<'list' | 'map'>('list');
    currentView: Observable<'list' | 'map'> = this.viewSource.asObservable();

    constructor() {}

    changeView(view: 'list' | 'map'): void {
        this.viewSource.next(view);
    }
}
